export const brandFavicons = [
  {
    "id": "becoder-favicon-ico",
    "rel": "icon",
    "type": "image/x-icon",
    "sizes": "16x16 32x32 48x48 256x256",
    "href": "/brand/bixing-20261102/favicon-20261102-v2.ico"
  },
  {
    "id": "becoder-favicon-png-32",
    "rel": "icon",
    "type": "image/png",
    "sizes": "32x32",
    "href": "/brand/bixing-20261102/favicon-32-20261102-v2.png"
  },
  {
    "id": "becoder-favicon-png-192",
    "rel": "icon",
    "type": "image/png",
    "sizes": "192x192",
    "href": "/brand/bixing-20261102/favicon-192-20261102-v2.png"
  },
  {
    "id": "becoder-favicon-svg",
    "rel": "icon",
    "type": "image/svg+xml",
    "sizes": "any",
    "href": "/brand/bixing-20261102/favicon-20261102-v2.svg"
  },
  {
    "id": "becoder-apple-touch-icon",
    "rel": "apple-touch-icon",
    "type": "image/png",
    "sizes": "180x180",
    "href": "/brand/bixing-20261102/apple-touch-icon-20261102-v2.png"
  }
] as const;

/** Keep versioned icon fallbacks stable across route changes. */
export function installBrandFavicons(doc: Document = document) {
  const ids = new Set<string>(brandFavicons.map(icon => icon.id));
  doc.querySelectorAll<HTMLLinkElement>('link[rel]').forEach(link => {
    if ((/(^|\s)icon(\s|$)/i.test(link.rel) || /apple-touch-icon/i.test(link.rel)) && !ids.has(link.id)) link.remove();
  });
  for (const icon of brandFavicons) {
    const link = doc.querySelector<HTMLLinkElement>(`link#${icon.id}`) || doc.createElement('link');
    link.id = icon.id;
    for (const name of ['rel', 'type', 'sizes', 'href'] as const) {
      if (link.getAttribute(name) !== icon[name]) link.setAttribute(name, icon[name]);
    }
    if (!link.isConnected) doc.head.appendChild(link);
  }
}
